import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { ContactFormValues } from "modules/contacts/Contacts";

const postContactForm = async (formData: ContactFormValues) => {
  const response = await axios.post(`/api/contact`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const useContactFormMutation = () => {
  return useMutation({
    mutationFn: postContactForm,
  });
};
